module.exports = "/_next/static/images/bad-250a89c3985a09b36beffa54babd695a.png";